module.exports = __webpack_public_path__ + "img/07-cnbm-win-logo.fb567330.png";